import type { Conversation } from '@/types/inbox.types';
import type { InboxNotification } from '@/types/inbox.types';
import { DEMO_CONTRACT_IDS } from '../demoContractData';

export const conversations: Conversation[] = [
  {
    id: 'dj-conv-1',
    subject: 'Coco Jones Recording Deal - Final Review',
    preview: 'Kecia Tatum: The recording deal terms are ready for your final review and sign-off...',
    participants: ['Mayowa', 'Kecia Tatum', 'Nicole Billings', 'High Standardz'],
    status: 'unread',
    priority: 'high',
    timestamp: '2026-03-19T10:30:00Z',
    relativeTime: '2 hours ago',
    messageCount: 5,
    unreadCount: 2,
    type: 'contract',
    actionRequired: true,
    metadata: {
      entityId: DEMO_CONTRACT_IDS.ARTIST_RECORDING_DEAL,
      entityName: 'Coco Jones - Recording Agreement',
      tags: ['urgent', 'recording-deal', 'recording'],
      relatedItems: [
        { id: 'dj-deal-1', name: 'Coco Jones - Recording Agreement', type: 'deal' },
      ],
    },
    messages: [
      {
        id: 'dj-msg-1',
        author: 'Nicole Billings',
        content: 'A&R has approved the creative terms for the Coco Jones recording deal. The album commitment, touring split, and merch provisions all look good from our side.',
        timestamp: '2026-03-18T14:00:00Z',
        relativeTime: 'Yesterday',
      },
      {
        id: 'dj-msg-2',
        author: 'Kecia Tatum',
        content: 'Thanks Nicole. I\'ve updated the agreement with the final royalty structure: 18% base rate, 20% touring, 25% merch. The $2.5M advance is structured in 3 installments tied to album delivery milestones.',
        timestamp: '2026-03-18T16:30:00Z',
        relativeTime: 'Yesterday',
        attachments: [{ name: 'Coco_Jones_Recording_v4.pdf', size: '3.2 MB', type: 'pdf' }],
      },
      {
        id: 'dj-msg-3',
        author: 'You',
        isCurrentUser: true,
        content: 'The structure looks solid. Can we confirm the worldwide territory scope includes the Nasty C JV territories?',
        timestamp: '2026-03-18T17:15:00Z',
        relativeTime: 'Yesterday',
        reactions: [{ emoji: '👍', count: 2, userReacted: false }],
      },
      {
        id: 'dj-msg-4',
        author: 'Kecia Tatum',
        content: 'Good catch — I\'ve added a carve-out for Nasty C JV territories in Section 12. The agreement now explicitly covers North America, Europe, and APAC, with Africa handled through the JV structure.',
        timestamp: '2026-03-19T09:00:00Z',
        relativeTime: '3 hours ago',
        attachments: [
          { name: 'Coco_Jones_Recording_v5_FINAL.pdf', size: '3.4 MB', type: 'pdf' },
          { name: 'Territory_Exhibit_B.pdf', size: '856 KB', type: 'pdf' },
        ],
      },
      {
        id: 'dj-msg-5',
        author: 'Kecia Tatum',
        content: 'The recording deal terms are ready for your final review and sign-off. Please review Sections 4 (royalties), 8 (touring), 10 (merch), and 12 (territories). Artist management needs our response by end of week.',
        timestamp: '2026-03-19T10:30:00Z',
        relativeTime: '2 hours ago',
        reactions: [{ emoji: '🎯', count: 1, userReacted: false }],
      },
    ],
  },
  {
    id: 'dj-conv-2',
    subject: 'Bieber Amendment - Signing Status',
    preview: 'Jeff Harleston: Legal has approved — moving to execution...',
    participants: ['Mayowa', 'Jeff Harleston', 'Kecia Tatum'],
    status: 'unread',
    priority: 'medium',
    timestamp: '2026-03-19T09:15:00Z',
    relativeTime: '3 hours ago',
    messageCount: 3,
    unreadCount: 1,
    type: 'deal',
    metadata: {
      entityId: 'dj-deal-2',
      entityName: 'Justin Bieber - Album 7 Amendment',
      tags: ['amendment', 'signing'],
      relatedItems: [],
    },
    messages: [
      {
        id: 'dj-msg-6',
        author: 'Kecia Tatum',
        content: 'The Bieber Album 7 amendment has completed legal review. The $12M advance structure and updated royalty terms are finalized.',
        timestamp: '2026-03-18T11:00:00Z',
        relativeTime: 'Yesterday',
      },
      {
        id: 'dj-msg-7',
        author: 'You',
        isCurrentUser: true,
        content: 'Great. Are we good to move to execution? Jeff — do you need a final walkthrough?',
        timestamp: '2026-03-18T14:30:00Z',
        relativeTime: 'Yesterday',
      },
      {
        id: 'dj-msg-8',
        author: 'Jeff Harleston',
        content: 'Legal has approved — moving to execution. I\'ve reviewed and am comfortable with the terms. Let\'s get this signed before end of month.',
        timestamp: '2026-03-19T09:15:00Z',
        relativeTime: '3 hours ago',
      },
    ],
  },
  {
    id: 'dj-conv-4',
    subject: 'Nasty C JV Update - Structure',
    preview: 'Marcus Reynolds: Got feedback from Nasty C\'s team on the sublabel...',
    participants: ['Mayowa', 'Marcus Reynolds', 'Jeff Harleston'],
    status: 'unread',
    priority: 'low',
    timestamp: '2026-03-18T16:30:00Z',
    relativeTime: 'Yesterday',
    messageCount: 2,
    unreadCount: 1,
    type: 'deal',
    metadata: {
      entityId: 'dj-deal-5',
      entityName: 'Nasty C JV',
      tags: ['jv', 'international'],
      relatedItems: [],
    },
    messages: [
      {
        id: 'dj-msg-11',
        author: 'Marcus Reynolds',
        content: 'Got feedback from Nasty C\'s team on the sublabel structure. They\'re aligned on the creative director role and $3M initial capitalization. Want to discuss territory expansion to include North Africa.',
        timestamp: '2026-03-18T16:30:00Z',
        relativeTime: 'Yesterday',
      },
      {
        id: 'dj-msg-12',
        author: 'Jeff Harleston',
        content: 'North Africa expansion is interesting — let\'s discuss in our next call. The $3M structure works for phase 1.',
        timestamp: '2026-03-18T17:00:00Z',
        relativeTime: 'Yesterday',
      },
    ],
  },
  {
    id: 'dj-conv-5',
    subject: 'Big Sean Catalog - Valuation Thread',
    preview: 'Kecia Tatum: Updated valuation model is attached...',
    participants: ['Mayowa', 'Kecia Tatum', 'Jeff Harleston', 'UMG Legal'],
    status: 'read',
    priority: 'medium',
    timestamp: '2026-03-17T14:00:00Z',
    relativeTime: '2 days ago',
    messageCount: 4,
    unreadCount: 0,
    type: 'deal',
    metadata: {
      entityId: 'dj-deal-12',
      entityName: 'Big Sean - Catalog Buyback',
      tags: ['catalog', 'valuation'],
      relatedItems: [],
    },
    messages: [
      {
        id: 'dj-msg-13',
        author: 'You',
        isCurrentUser: true,
        content: 'Where are we on the Big Sean catalog valuation? His team is pushing for $10M based on streaming projections.',
        timestamp: '2026-03-17T10:00:00Z',
        relativeTime: '2 days ago',
      },
      {
        id: 'dj-msg-14',
        author: 'Kecia Tatum',
        content: 'Updated valuation model is attached. Our analysis supports $8.5M based on 5-year DCF of streaming revenue. The $10M ask is aggressive given declining catalog streams.',
        timestamp: '2026-03-17T14:00:00Z',
        relativeTime: '2 days ago',
        attachments: [{ name: 'BigSean_Catalog_Valuation_v3.xlsx', size: '1.8 MB', type: 'pdf' }],
      },
      {
        id: 'dj-msg-15',
        author: 'Jeff Harleston',
        content: 'I agree with the $8.5M valuation. We should hold firm — the streaming data supports our position.',
        timestamp: '2026-03-17T15:00:00Z',
        relativeTime: '2 days ago',
      },
      {
        id: 'dj-msg-16',
        author: 'You',
        isCurrentUser: true,
        content: 'Agreed. I\'ll communicate our position to Sean\'s team and propose a structured payment plan to make it palatable.',
        timestamp: '2026-03-17T16:00:00Z',
        relativeTime: '2 days ago',
        reactions: [{ emoji: '🎯', count: 2, userReacted: false }],
      },
    ],
  },
  {
    id: 'dj-conv-6',
    subject: 'Nike Sync Terms - 2 Chainz',
    preview: 'Sasha Robinson: Nike brand team sent over initial sync terms...',
    participants: ['Mayowa', 'Sasha Robinson', 'Tanya Brooks'],
    status: 'read',
    priority: 'medium',
    timestamp: '2026-03-16T09:00:00Z',
    relativeTime: '3 days ago',
    messageCount: 3,
    unreadCount: 0,
    type: 'contract',
    metadata: {
      entityId: 'dj-deal-6',
      entityName: '2 Chainz - Nike Sync License',
      tags: ['sync', 'brand'],
      relatedItems: [],
    },
    messages: [
      {
        id: 'dj-msg-17',
        author: 'Sasha Robinson',
        content: 'Nike brand team sent over initial sync terms for the 2 Chainz Air Max campaign. $750K for 12-month usage across TV, digital, and social.',
        timestamp: '2026-03-16T09:00:00Z',
        relativeTime: '3 days ago',
        attachments: [{ name: 'Nike_Sync_Proposal.pdf', size: '1.2 MB', type: 'pdf' }],
      },
      {
        id: 'dj-msg-18',
        author: 'You',
        isCurrentUser: true,
        content: 'The fee looks fair for 12 months. But let\'s negotiate the exclusivity — we should keep rights to license to other shoe brands after 6 months.',
        timestamp: '2026-03-16T11:00:00Z',
        relativeTime: '3 days ago',
      },
      {
        id: 'dj-msg-19',
        author: 'Sasha Robinson',
        content: 'Good point. I\'ll push back on the exclusivity window and propose a 6-month exclusive with non-compete carve-outs.',
        timestamp: '2026-03-16T14:00:00Z',
        relativeTime: '3 days ago',
        reactions: [{ emoji: '👍', count: 1, userReacted: false }],
      },
    ],
  },
];

export const notifications: InboxNotification[] = [
  {
    id: 'dj-notif-1',
    type: 'contract',
    title: 'Recording deal requires review',
    description: 'Coco Jones Recording Agreement is ready for your final review',
    priority: 'high',
    status: 'unread',
    timestamp: '2026-03-19T10:30:00Z',
    relativeTime: '2 hours ago',
    actionRequired: true,
    metadata: {
      entityId: 'dj-deal-1',
      entityName: 'Coco Jones - Recording Agreement',
      actor: 'Kecia Tatum',
      participants: ['Mayowa', 'Kecia Tatum', 'Nicole Billings'],
      relatedItems: [{ id: 'dj-deal-1', name: 'Coco Jones Recording Agreement', type: 'deal' }],
      tags: ['urgent', 'recording-deal'],
      attachments: [{ name: 'Coco_Jones_Recording_v5.pdf', size: '3.4 MB', type: 'pdf' }],
    },
  },
  {
    id: 'dj-notif-2',
    type: 'deal',
    title: 'Deal moved to Signing',
    description: 'Justin Bieber - Album 7 Amendment moved to Signing stage',
    priority: 'medium',
    status: 'unread',
    timestamp: '2026-03-19T09:15:00Z',
    relativeTime: '3 hours ago',
    metadata: {
      entityId: 'dj-deal-2',
      entityName: 'Justin Bieber - Album 7 Amendment',
      actor: 'Jeff Harleston',
      participants: ['Mayowa', 'Jeff Harleston', 'Kecia Tatum'],
      relatedItems: [],
      tags: ['amendment', 'signing'],
    },
  },
  {
    id: 'dj-notif-4',
    type: 'deal',
    title: 'Producer deal ready for signature',
    description: 'Phil The Keys producer agreement finalized — awaiting signature',
    priority: 'medium',
    status: 'unread',
    timestamp: '2026-03-18T16:30:00Z',
    relativeTime: 'Yesterday',
    actionRequired: true,
    metadata: {
      entityId: 'dj-deal-8',
      entityName: 'Phil The Keys - Producer Agreement',
      participants: ['Mayowa', 'Nicole Billings', 'Sasha Robinson'],
      relatedItems: [],
      tags: ['producer', 'signature'],
    },
  },
  {
    id: 'dj-notif-5',
    type: 'deal',
    title: 'New sync opportunity',
    description: 'Nike submitted sync license proposal for 2 Chainz catalog',
    priority: 'medium',
    status: 'read',
    timestamp: '2026-03-16T09:00:00Z',
    relativeTime: '3 days ago',
    metadata: {
      entityId: 'dj-deal-6',
      entityName: '2 Chainz - Nike Sync License',
      actor: 'Sasha Robinson',
      participants: ['Mayowa', 'Sasha Robinson'],
      relatedItems: [],
      tags: ['sync', 'nike'],
    },
  },
  {
    id: 'dj-notif-6',
    type: 'document',
    title: 'Catalog valuation updated',
    description: 'Big Sean catalog valuation model v3 uploaded by Kecia Tatum',
    priority: 'low',
    status: 'read',
    timestamp: '2026-03-17T14:00:00Z',
    relativeTime: '2 days ago',
    metadata: {
      entityId: 'dj-deal-12',
      entityName: 'Big Sean - Catalog Buyback',
      actor: 'Kecia Tatum',
      participants: ['Mayowa', 'Kecia Tatum', 'Jeff Harleston'],
      relatedItems: [],
      tags: ['catalog', 'valuation'],
      attachments: [{ name: 'BigSean_Catalog_Valuation_v3.xlsx', size: '1.8 MB', type: 'pdf' }],
    },
  },
  {
    id: 'dj-notif-7',
    type: 'deal',
    title: 'Distribution deal completed',
    description: 'LL Cool J distribution deal marked as complete',
    priority: 'low',
    status: 'read',
    timestamp: '2026-03-10T15:00:00Z',
    relativeTime: '1 week ago',
    metadata: {
      entityId: 'dj-deal-4',
      entityName: 'LL Cool J - Distribution Deal',
      participants: ['Mayowa', 'Marcus Reynolds'],
      relatedItems: [],
      tags: ['completed', 'distribution'],
    },
  },
  {
    id: 'dj-notif-8',
    type: 'contract',
    title: 'Deadline reminder',
    description: 'LiAngelo Ball recording agreement delivery deadline in 4 weeks',
    priority: 'medium',
    status: 'read',
    timestamp: '2026-03-15T09:00:00Z',
    relativeTime: '4 days ago',
    metadata: {
      entityId: 'dj-deal-7',
      entityName: 'LiAngelo Ball - Recording Agreement',
      participants: ['Mayowa', 'Nicole Billings', 'Kecia Tatum'],
      relatedItems: [],
      tags: ['deadline', 'delivery'],
    },
  },
];
